"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HousesStatistic = require("./HousesStatistic");
Object.keys(_HousesStatistic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HousesStatistic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HousesStatistic[key];
    }
  });
});